import { createFileRoute } from '@tanstack/react-router'

import { CustomerScreen } from '@/features/customers/customer-screen'

/** One customer's page, reached from their row in the list or from an eval's Customer panel. */
export const Route = createFileRoute('/_app/_org/customers/$customerId')({
  component: function CustomerRoute() {
    const { customerId } = Route.useParams()
    return <CustomerScreen key={customerId} customerId={customerId} />
  },
})
